import { render, staticRenderFns } from "./PortCard.vue?vue&type=template&id=0cbb8b7b&scoped=true"
import script from "./PortCard.vue?vue&type=script&lang=js"
export * from "./PortCard.vue?vue&type=script&lang=js"
import style0 from "./PortCard.vue?vue&type=style&index=0&id=0cbb8b7b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbb8b7b",
  null
  
)

export default component.exports